
import React, { useState, useEffect } from 'react'
import { Modal } from 'react-bootstrap';

import AuthUser from '../../components/AuthUser';

import { ClientesSupervisorXLS } from '../XLS/ClientesSupervisorXLS';
import { formatNumber } from '../../utils/formats';
import { getVendedor, RequestPage } from '../../api/request';
import { getVentasClientes, getDetalleClientesAtendidosxVendedor, getClientesDesatendidosByVendedor, getClientes, getClientePorRif, getClientesVendedorFecha, getClientesVendedorFecha2, getClientesVendedorFecha3, getClientesVendedorFecha4, getClientesAtendidosByGerente, getClientePorRif2 } from '../../api/requestClientes';
import { getDetalleClientesPorCodigo } from '../../api/requestClientes';
import { format, set } from 'date-fns';

// import 'chart.js/auto';
// import { Chart } from 'react-chartjs-2';

import Chart from "react-apexcharts";

import { RiCloseCircleFill } from "react-icons/ri";
import { SlOptionsVertical } from "react-icons/sl";

import Pagination from 'react-responsive-pagination';

export const DetalleCliente = (props) => {

  var Clientes = props.item
  var firstDay = props.fechaInicio
  var lastDay = props.fechaFin

  // State del usuario
  const { user } = AuthUser();

  // States del modal
  const [fullscreen, setFullscreen] = useState(true);
  const [show, setShow] = useState(false);
  const [showDetalleCliente, setShowDetalleCliente] = useState(false);

  // State del loading
  const [loading, setLoading] = useState(true);

  // State de datos
  const [gerente, setGerente] = useState(user.CodGerente);
  const [modulo, setModulo] = useState('');
  const [chartData, setChartData] = useState({});
  const [vendedorInfo, setVendedorInfo] = useState([])
  const [clientesAttData, setClientesAttData] = useState([]);
  const [clienteData, setClienteData] = useState({})

  // Paginación
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [urlPage, setUrlPage] = useState('');
  const [currentPage, setCurrentPage] = useState(1);

  const [ventas2022, setVentas2022] = useState([]);
  const [ventas2023, setVentas2023] = useState([]);
  const [ventas2024, setVentas2024] = useState([]);
  const [ventas2025, setVentas2025] = useState([]);

  // filtros UI
const [searchType, setSearchType] = useState('');
const [searchValue, setSearchValue] = useState('');
const [fechaInicio, setFechaInicio] = useState(''); // formato yyyy-mm-dd (input date)
const [fechaFin, setFechaFin] = useState('');
const [filteredClientes, setFilteredClientes] = useState([]);

// helper para saber si estamos aplicando filtro cliente-side
const isClientFilterActive = searchType && searchType !== 'Fecha' && searchValue;


  const labels = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];

  const getArrayDiff = (data) => {
    var datosArr = [
      {
        vendedor: clienteData.Vendedor,
        months: 'ENERO',
        ventas: 0,
        year: data[0].year,
        codcliente: clienteData.Codigo,
      },
      {
        vendedor: clienteData.Vendedor,
        months: 'FEBRERO',
        ventas: 0,
        year: data[0].year,
        codcliente: clienteData.Codigo,
      },
      {
        vendedor: clienteData.Vendedor,
        months: 'MARZO',
        ventas: 0,
        year: data[0].year,
        codcliente: clienteData.Codigo,
      },
      {
        vendedor: clienteData.Vendedor,
        months: 'ABRIL',
        ventas: 0,
        year: data[0].year,
        codcliente: clienteData.Codigo,
      },
      {
        vendedor: clienteData.Vendedor,
        months: 'MAYO',
        ventas: 0,
        year: data[0].year,
        codcliente: clienteData.Codigo,
      },
      {
        vendedor: clienteData.Vendedor,
        months: 'JUNIO',
        ventas: 0,
        year: data[0].year,
        codcliente: clienteData.Codigo,
      },
      {
        vendedor: clienteData.Vendedor,
        months: 'JULIO',
        ventas: 0,
        year: data[0].year,
        codcliente: clienteData.Codigo,
      },
      {
        vendedor: clienteData.Vendedor,
        months: 'AGOSTO',
        ventas: 0,
        year: data[0].year,
        codcliente: clienteData.Codigo,
      },
      {
        vendedor: clienteData.Vendedor,
        months: 'SEPTIEMBRE',
        ventas: 0,
        year: data[0].year,
        codcliente: clienteData.Codigo,
      },
      {
        vendedor: clienteData.Vendedor,
        months: 'OCTUBRE',
        ventas: 0,
        year: data[0].year,
        codcliente: clienteData.Codigo,
      },
      {
        vendedor: clienteData.Vendedor,
        months: 'NOVIEMBRE',
        ventas: 0,
        year: data[0].year,
        codcliente: clienteData.Codigo,
      },
      {
        vendedor: clienteData.Vendedor,
        months: 'DICIEMBRE',
        ventas: 0,
        year: data[0].year,
        codcliente: clienteData.Codigo,
      }
    ]

    const completeArray = datosArr.map(monthObj => {
      const matchingData = data.find(dataObj => dataObj.months === monthObj.months && dataObj.year === monthObj.year);
      return { ...monthObj, ventas: matchingData?.ventas || 0 };
    });

    return completeArray;
  }

  // helper: reemplaza/añade page en una URL sin romper otros params
function replacePageInUrl(url, pageNumber) {
  if (!url) return url;
  // normalizar: si viene con dominio (http...) o relativo (/api/...)
  let u = String(url);

  // Si ya tiene page param, reemplazar
  if (u.match(/([?&])page=\d+/)) {
    return u.replace(/([?&])page=\d+/, `$1page=${pageNumber}`);
  }

  // Si tiene query params pero no page
  if (u.includes('?')) {
    return `${u}&page=${pageNumber}`;
  }

  // si no tiene query params
  return `${u}?page=${pageNumber}`;
}

  // handlePageChange corregido
const handlePageChange = async (page) => {
  console.log('[handlePageChange] modulo, page:', modulo, page);
  setCurrentPage(page);

  // Para supervisores/gerentes delegamos en loadClientesVendedor que soporta page
  if (user.CodSupervisor !== null || user.CodGerente !== null) {
    await loadClientesVendedor(modulo, page);
    return;
  }

  // Legacy (vendedor): construir url con page y loadPage()
  if (urlPage) {
    const target = replacePageInUrl(urlPage, page);
    await loadPage(target);
  } else {
    // fallback legacy url
    const fallback = `/api/getClientesDesatendidosByVendedor?CodigoVendedor=${encodeURIComponent(Clientes.Vendedor)}&loadDesatendidos=General&page=${page}`;
    await loadPage(fallback);
  }
};






  const loadChart = async (CodigoCliente) => {
    setLoading(true)
    if (user.CodVendedor !== null && user.CodSupervisor === null && user.CodGerente !== null) {
      const clientData = await getClientePorRif(CodigoCliente, Clientes.Vendedor)
      setClienteData(clientData)
    }

    if (user.Usuario === 'haboulmouna' || user.Usuario === 'cobranzasbg') {
      const clientData = await getClientePorRif2(CodigoCliente)
      setClienteData(clientData)
    }

    const infoVendedor = await getVendedor(Clientes.Vendedor);
    setVendedorInfo(infoVendedor[0].Nombre)
    try {
      const respuesta = await getClientesVendedorFecha(CodigoCliente);
      const respuesta2 = await getClientesVendedorFecha2(CodigoCliente);
      const respuesta3 = await getClientesVendedorFecha3(CodigoCliente);
      const respuesta4 = await getClientesVendedorFecha4(CodigoCliente);
  
      
        const year = respuesta.year;
        const year2 = respuesta2.year;
        const year3 = respuesta3.year;
        const year4 = respuesta4.year;


        if (year === 2022 && year4 !== null) {
          const data2022 = await getVentasClientes('2022', CodigoCliente)
          const data2023 = await getVentasClientes('2023', CodigoCliente)
          const data2024 = await getVentasClientes('2024', CodigoCliente)
          const data2025 = await getVentasClientes('2025', CodigoCliente)

          const arr2022 = getArrayDiff(data2022)
          const arr2023 = getArrayDiff(data2023)
          const arr2024 = getArrayDiff(data2024)
          const arr2025 = getArrayDiff(data2025)

          const dataVentas2022 = labels.map(label => {
            const existingData = data2022.find(item => item.months.toLowerCase() === label.toLowerCase());
            if (existingData) {
              return existingData;
            } else {
              return { vendedor: '', months: label, ventas: 0, year: 2022 };
            }
          });
          setVentas2022(dataVentas2022)

          const dataVentas2023 = labels.map(label => {
            const existingData = data2023.find(item => item.months.toLowerCase() === label.toLowerCase());
            if (existingData) {
              return existingData;
            } else {
              return { vendedor: '', months: label, ventas: 0, year: 2023 };
            }
          });
          setVentas2023(dataVentas2023)

          const dataVentas2024 = labels.map(label => {
            const existingData = data2024.find(item => item.months.toLowerCase() === label.toLowerCase());
            if (existingData) {
              return existingData;
            } else {
              return { vendedor: '', months: label, ventas: 0, year: 2024 };
            }
          });
          setVentas2024(dataVentas2024)

          const dataVentas2025 = labels.map(label => {
            const existingData = data2025.find(item => item.months.toLowerCase() === label.toLowerCase());
            if (existingData) {
              return existingData;
            } else {
              return { vendedor: '', months: label, ventas: 0, year: 2025 };
            }
          });
          setVentas2022(dataVentas2025)

          // setVentas2025(data2025)
          // setVentas2024(data2024)
          // setVentas2023(data2023)
          // setVentas2022(data2022)
          sortByMonth(arr2022)
          sortByMonth(arr2023)
          sortByMonth(arr2024)

          setChartData({
            options: {
              chart: {
                id: "chart-VentasAnuales",
                type: "area"
              },
              xaxis: {
                categories: labels
              },
              fill: {
                type: "gradient",
                gradient: {
                  shadeIntensity: 1,
                  opacityFrom: 0.7,
                  opacityTo: 0.9,
                  stops: [0, 90, 100]
                }
              },
              colors: ['#f28b05','#52d689', '#0041ff', '#d62915'],
              dataLabels: {
                enabled: false
              },
            },
            series: [
              {
                name: 'Ventas del año 2025 en USD',
                data: arr2025.map((Ventas) => Ventas.ventas)
              },
              {
                name: 'Ventas del año 2024 en USD',
                data: arr2024.map((Ventas) => Ventas.ventas)
              },
              {
                name: 'Ventas del año 2023 en USD',
                data: arr2023.map((Ventas) => Ventas.ventas)
              },
              {
                name: 'Ventas del año 2022 en USD',
                data: arr2022.map((Ventas) => Ventas.ventas)
              }
            ]
          })

        } if (year === 2022 && year4 === null) {
          const data2022 = await getVentasClientes('2022', CodigoCliente)
          const data2023 = await getVentasClientes('2023', CodigoCliente)
          const data2024 = await getVentasClientes('2024', CodigoCliente)

          const arr2022 = getArrayDiff(data2022)
          const arr2023 = getArrayDiff(data2023)
          const arr2024 = getArrayDiff(data2024)

          const dataVentas2022 = labels.map(label => {
            const existingData = data2022.find(item => item.months.toLowerCase() === label.toLowerCase());
            if (existingData) {
              return existingData;
            } else {
              return { vendedor: '', months: label, ventas: 0, year: 2022 };
            }
          });
          setVentas2022(dataVentas2022)

          const dataVentas2023 = labels.map(label => {
            const existingData = data2023.find(item => item.months.toLowerCase() === label.toLowerCase());
            if (existingData) {
              return existingData;
            } else {
              return { vendedor: '', months: label, ventas: 0, year: 2023 };
            }
          });
          setVentas2023(dataVentas2023)

          const dataVentas2024 = labels.map(label => {
            const existingData = data2024.find(item => item.months.toLowerCase() === label.toLowerCase());
            if (existingData) {
              return existingData;
            } else {
              return { vendedor: '', months: label, ventas: 0, year: 2024 };
            }
          });
          setVentas2024(dataVentas2024)

          // setVentas2024(data2024)
          // setVentas2023(data2023)
          // setVentas2022(data2022)
          sortByMonth(arr2022)
          sortByMonth(arr2023)
          sortByMonth(arr2024)

          setChartData({
            options: {
              chart: {
                id: "chart-VentasAnuales",
                type: "area"
              },
              xaxis: {
                categories: labels
              },
              fill: {
                type: "gradient",
                gradient: {
                  shadeIntensity: 1,
                  opacityFrom: 0.7,
                  opacityTo: 0.9,
                  stops: [0, 90, 100]
                }
              },
              colors: ['#52d689', '#0041ff', '#d62915'],
              dataLabels: {
                enabled: false
              },
            },
            series: [
              {
                name: 'Ventas del año 2024 en USD',
                data: arr2024.map((Ventas) => Ventas.ventas)
              },
              {
                name: 'Ventas del año 2023 en USD',
                data: arr2023.map((Ventas) => Ventas.ventas)
              },
              {
                name: 'Ventas del año 2022 en USD',
                data: arr2022.map((Ventas) => Ventas.ventas)
              }
            ]
          })

        } else if (year2 === 2023 && year4 !== null) {
          const data2023 = await getVentasClientes('2023', CodigoCliente)
          const data2024 = await getVentasClientes('2024', CodigoCliente)
          const data2025 = await getVentasClientes('2025', CodigoCliente)

          const arr2023 = getArrayDiff(data2023)
          const arr2024 = getArrayDiff(data2024)
          const arr2025 = getArrayDiff(data2025)

          const dataVentas2025 = labels.map(label => {
            const existingData = data2025.find(item => item.months.toLowerCase() === label.toLowerCase());
            if (existingData) {
              return existingData;
            } else {
              return { vendedor: '', months: label, ventas: 0, year: 2025 };
            }
          });

          setVentas2025(dataVentas2025)
          const dataVentas2024 = labels.map(label => {
            const existingData = data2024.find(item => item.months.toLowerCase() === label.toLowerCase());
            if (existingData) {
              return existingData;
            } else {
              return { vendedor: '', months: label, ventas: 0, year: 2024 };
            }
          });

          setVentas2024(dataVentas2024)
          const dataVentas2023 = labels.map(label => {
            const existingData = data2023.find(item => item.months.toLowerCase() === label.toLowerCase());
            if (existingData) {
              return existingData;
            } else {
              return { vendedor: '', months: label, ventas: 0, year: 2023 };
            }
          });

          setVentas2023(dataVentas2023)
          // setVentas2024(data2024)
          // setVentas2023(data2023)
          sortByMonth(arr2023)
          sortByMonth(arr2024)
          sortByMonth(arr2025)

          setChartData({
            options: {
              chart: {
                id: "chart-VentasAnuales",
                type: "area"
              },
              xaxis: {
                categories: labels
              },
              fill: {
                type: "gradient",
                gradient: {
                  shadeIntensity: 1,
                  opacityFrom: 0.7,
                  opacityTo: 0.9,
                  stops: [0, 90, 100]
                }
              },
              colors: ['#f28b05','#52d689', '#0041ff'],
              dataLabels: {
                enabled: false
              },
            },
            series: [
              {
                name: 'Ventas del año 2025 en USD',
                data: arr2025.map((Ventas) => Ventas.ventas)
              },
              {
                name: 'Ventas del año 2024 en USD',
                data: arr2024.map((Ventas) => Ventas.ventas)
              },
              {
                name: 'Ventas del año 2023 en USD',
                data: arr2023.map((Ventas) => Ventas.ventas)
              }
            ]
          })
        } else if (year2 === 2023 && year4 === null) {
          const data2023 = await getVentasClientes('2023', CodigoCliente)
          const data2024 = await getVentasClientes('2024', CodigoCliente)

          const arr2023 = getArrayDiff(data2023)
          const arr2024 = getArrayDiff(data2024)

          const dataVentas2023 = labels.map(label => {
            const existingData = data2023.find(item => item.months.toLowerCase() === label.toLowerCase());
            if (existingData) {
              return existingData;
            } else {
              return { vendedor: '', months: label, ventas: 0, year: 2023 };
            }
          });

          setVentas2023(dataVentas2023)
          const dataVentas2024 = labels.map(label => {
            const existingData = data2024.find(item => item.months.toLowerCase() === label.toLowerCase());
            if (existingData) {
              return existingData;
            } else {
              return { vendedor: '', months: label, ventas: 0, year: 2024 };
            }
          });

          setVentas2025(dataVentas2024)
          sortByMonth(arr2023)
          sortByMonth(arr2024)

          setChartData({
            options: {
              chart: {
                id: "chart-VentasAnuales",
                type: "area"
              },
              xaxis: {
                categories: labels
              },
              fill: {
                type: "gradient",
                gradient: {
                  shadeIntensity: 1,
                  opacityFrom: 0.7,
                  opacityTo: 0.9,
                  stops: [0, 90, 100]
                }
              },
              colors: ['#52d689', '#0041ff'],
              dataLabels: {
                enabled: false
              },
            },
            series: [
              {
                name: 'Ventas del año 2024 en USD',
                data: arr2024.map((Ventas) => Ventas.ventas)
              },
              {
                name: 'Ventas del año 2023 en USD',
                data: arr2023.map((Ventas) => Ventas.ventas)
              }
            ]
          })
        } else if(year3=== 2024 && year4 !== null) {
          const data2024 = await getVentasClientes('2024', CodigoCliente)
          const data2025 = await getVentasClientes('2025', CodigoCliente)

          const arr2024 = getArrayDiff(data2024)
          const arr2025 = getArrayDiff(data2025)
          const dataVentas2024 = labels.map(label => {
            const existingData = data2024.find(item => item.months.toLowerCase() === label.toLowerCase());
            if (existingData) {
              return existingData;
            } else {
              return { vendedor: '', months: label, ventas: 0, year: 2024 };
            }
          });

          setVentas2024(dataVentas2024)
          const dataVentas2025 = labels.map(label => {
            const existingData = data2025.find(item => item.months.toLowerCase() === label.toLowerCase());
            if (existingData) {
              return existingData;
            } else {
              return { vendedor: '', months: label, ventas: 0, year: 2025 };
            }
          });

          setVentas2025(dataVentas2025)
          sortByMonth(arr2024)
          sortByMonth(arr2025)

          setChartData({
            options: {
              chart: {
                id: "chart-VentasAnuales",
                type: "area"
              },
              xaxis: {
                categories: labels
              },
              fill: {
                type: "gradient",
                gradient: {
                  shadeIntensity: 1,
                  opacityFrom: 0.7,
                  opacityTo: 0.9,
                  stops: [0, 90, 100]
                }
              },
              colors: ['#f28b05','#52d689'],
              dataLabels: {
                enabled: false
              },
            },
            series: [
              {
                name: 'Ventas del año 2025 en USD',
                data: arr2025.map((Ventas) => Ventas.ventas)
              },
              {
                name: 'Ventas del año 2024 en USD',
                data: arr2024.map((Ventas) => Ventas.ventas)
              }
            ]
          })
        } else if(year3=== 2024 && year4 === null) {
          const data2024 = await getVentasClientes('2024', CodigoCliente)

          const arr2024 = getArrayDiff(data2024)
          const dataVentas2024 = labels.map(label => {
            const existingData = data2024.find(item => item.months.toLowerCase() === label.toLowerCase());
            if (existingData) {
              return existingData;
            } else {
              return { vendedor: '', months: label, ventas: 0, year: 2024 };
            }
          });

          setVentas2024(dataVentas2024)
          sortByMonth(arr2024)

          setChartData({
            options: {
              chart: {
                id: "chart-VentasAnuales",
                type: "area"
              },
              xaxis: {
                categories: labels
              },
              fill: {
                type: "gradient",
                gradient: {
                  shadeIntensity: 1,
                  opacityFrom: 0.7,
                  opacityTo: 0.9,
                  stops: [0, 90, 100]
                }
              },
              colors: ['#52d689'],
              dataLabels: {
                enabled: false
              },
            },
            series: [
              {
                name: 'Ventas del año 2024 en USD',
                data: arr2024.map((Ventas) => Ventas.ventas)
              }
            ]
          })
        } else if(year4=== 2025) {
          const data2025 = await getVentasClientes('2025', CodigoCliente)

           const arr2025 = getArrayDiff(data2025)
           
          sortByMonth(arr2025)

          const dataVentas2025 = labels.map(label => {
            const existingData = data2025.find(item => item.months.toLowerCase() === label.toLowerCase());
            if (existingData) {
              return existingData;
            } else {
              return { vendedor: '', months: label, ventas: 0, year: 2025 };
            }
          });

          setVentas2025(dataVentas2025)

          setChartData({
            options: {
              chart: {
                id: "chart-VentasAnuales",
                type: "area"
              },
              xaxis: {
                categories: labels
              },
              fill: {
                type: "gradient",
                gradient: {
                  shadeIntensity: 1,
                  opacityFrom: 0.7,
                  opacityTo: 0.9,
                  stops: [0, 90, 100]
                }
              },
              colors: ['#f28b05'],
              dataLabels: {
                enabled: false
              },
            },
            series: [
              {
                name: 'Ventas del año 2025 en USD',
                data: arr2025.map((Ventas) => Ventas.ventas)
              }
            ]
          })
        } else if(year4=== null && year === null && year2 === null && year3 === null ) {
         

          setChartData({
            options: {
              chart: {
                id: "chart-VentasAnuales",
                type: "area"
              },
              xaxis: {
                categories: labels
              },
              fill: {
                type: "gradient",
                gradient: {
                  shadeIntensity: 1,
                  opacityFrom: 0.7,
                  opacityTo: 0.9,
                  stops: [0, 90, 100]
                }
              },
              colors: ['#f28b05'],
              dataLabels: {
                enabled: false
              },
            },
            series: [
              {
                name: 'No posee data actual'
              }
            ]
          })
        }
  
    }
     catch (error) {
      console.error("Error al obtener el año:", error);
    }
    

    

    

    

    setLoading(false)
  }

const loadClientesVendedor = async (whichToLoad, pageToLoad = 1) => {
  setLoading(true);
  setModulo(whichToLoad);

  try {
    // Si soy Supervisor o Gerente -> delegar siempre al endpoint unificado (paginado)
    if (user.CodSupervisor !== null || user.CodGerente !== null) {
      // Delegar a fetchDetallePage (NO llamamos a loadClientesVendedor desde ahi)
      await fetchDetallePage(whichToLoad, pageToLoad);
      return;
    }

    // Legacy: si soy vendedor, usar endpoints legacy
    switch (whichToLoad) {
      case 'activos': {
        const resActivos = await getClientes(Clientes.Vendedor);
        setClientesAttData(resActivos?.data || []);
        setPage(resActivos?.current_page || 1);
        setCurrentPage(resActivos?.current_page || 1);
        setTotalPages(resActivos?.last_page || 1);
        setUrlPage(resActivos?.first_page_url || '');
        break;
      }
      case 'atendidos': {
        // Si tu backend legacy no soporta paginado, llama al helper pero respondiendo en array
        const resAtendidos = await getDetalleClientesAtendidosxVendedor(Clientes.Vendedor, firstDay, lastDay, 1);
        // Normaliza: si helper devolvió paginado o array
        if (resAtendidos?.data !== undefined) {
          setClientesAttData(resAtendidos.data || []);
          setPage(resAtendidos.current_page || 1);
          setCurrentPage(resAtendidos.current_page || 1);
          setTotalPages(resAtendidos.last_page || 1);
          setUrlPage(resAtendidos.first_page_url || '');
        } else {
          setClientesAttData(Array.isArray(resAtendidos) ? resAtendidos : resAtendidos || []);
          setPage(1); setCurrentPage(1); setTotalPages(1); setUrlPage('');
        }
        break;
      }
      case 'desatendidos': {
        const resDesatendidos = await getClientesDesatendidosByVendedor(Clientes.Vendedor, firstDay, lastDay, 1);
        if (resDesatendidos?.data !== undefined) {
          setClientesAttData(resDesatendidos.data || []);
          setCurrentPage(resDesatendidos.current_page || 1);
          setPage(resDesatendidos.current_page || 1);
          setTotalPages(resDesatendidos.last_page || 1);
          setUrlPage(resDesatendidos.first_page_url || '');
        } else {
          setClientesAttData(Array.isArray(resDesatendidos) ? resDesatendidos : resDesatendidos || []);
          setPage(1); setCurrentPage(1); setTotalPages(1); setUrlPage('');
        }
        break;
      }
      default: {
        const resActivosD = await getClientes(Clientes.Vendedor);
        setClientesAttData(resActivosD?.data || []);
        setPage(resActivosD?.current_page || 1);
        setCurrentPage(resActivosD?.current_page || 1);
        setTotalPages(resActivosD?.last_page || 1);
        setUrlPage(resActivosD?.first_page_url || '');
        break;
      }
    }
  } catch (err) {
    console.error('loadClientesVendedor error', err);
    setClientesAttData([]);
    setPage(1); setCurrentPage(1); setTotalPages(0); setUrlPage('');
  } finally {
    setLoading(false);
  }
};






// loadPage: hace la petición a cualquier first_page_url / next_page_url (relativa o absoluta)
const loadPage = async (pageUrl) => {
  setLoading(true);
  try {
    // RequestPage espera una URL (relativa o absoluta). Asegurate que envía axios.get(pageUrl)
    const clienteData = await RequestPage(pageUrl);

    // Normalizar respuesta paginada
    if (clienteData && clienteData.data !== undefined) {
      setClientesAttData(clienteData.data || []);
      setPage(clienteData.current_page || 1);
      setCurrentPage(clienteData.current_page || 1);
      setTotalPages(clienteData.last_page || 1);
      setUrlPage(clienteData.first_page_url || '');
    } else if (Array.isArray(clienteData)) {
      setClientesAttData(clienteData);
      setPage(1); setCurrentPage(1); setTotalPages(1); setUrlPage('');
    } else {
      // si RequestPage devolvió objeto inesperado
      console.warn('loadPage: respuesta inesperada', clienteData);
      setClientesAttData([]);
      setPage(1); setCurrentPage(1); setTotalPages(0); setUrlPage('');
    }

  } catch (err) {
    console.error('loadPage error', err);
    setClientesAttData([]);
    setPage(1); setCurrentPage(1); setTotalPages(0); setUrlPage('');
  } finally {
    setLoading(false);
  }
};



  function sortByMonth(arr) {
    var months = ["ENERO", "FEBRERO", "MARZO", "ABRIL", "MAYO", "JUNIO",
      "JULIO", "AGOSTO", "SEPTIEMBRE", "OCTUBRE", "NOVIEMBRE", "DICIEMBRE"];
    arr.sort(function (a, b) {
      return months.indexOf(a.months)
        - months.indexOf(b.months);
    });
  }

  function handleShow(whichToLoad) {
  console.log('[handleShow] whichToLoad:', whichToLoad, 'Clientes prop:', Clientes);
  setFullscreen(true);
  setShow(true);
  if (user.CodGerente === null) {
    loadChart(Clientes.Codigo);
  } else if (user.CodGerente !== null) {
    loadClientesVendedor(whichToLoad);
  }
}


  function handleShowDetalleCliente(CodigoCliente) {
    setFullscreen(true);
    setShowDetalleCliente(true);
    loadChart(CodigoCliente);
  }

  useEffect(() => {
  }, []);

  // Helper: pide la "page" correcta para el modo actual y normaliza la respuesta
// Helper: pide la "page" correcta para el modo actual y normaliza la respuesta
const fetchDetallePage = async (whichToLoad, pageToLoad = 1) => {
  setLoading(true);
  try {
    // Normalizar codigo desde el item Cliente
    const codigoRaw = Clientes?.Vendedor ?? Clientes?.CodVendedor ?? Clientes?.clientes ?? Clientes?.Codigo ?? '';
    const codigo = String(codigoRaw || '').toUpperCase();

    console.log('[fetchDetallePage] params ->', { whichToLoad, pageToLoad, codigo, firstDay, lastDay, user });

    // Si no hay codigo, devolver vacío (pero loguear para debug)
    if (!codigo) {
      console.warn('[fetchDetallePage] codigo vacío, abortando request');
      setClientesAttData([]);
      setPage(1); setCurrentPage(1); setTotalPages(0); setUrlPage('');
      return;
    }

    // Llamada unificada al helper que arma la URL y devuelve paginado
    const res = await getDetalleClientesPorCodigo(codigo, whichToLoad || 'activos', firstDay, lastDay, pageToLoad, true);
    console.log('[fetchDetallePage] response ->', res);

    if (!res) {
      setClientesAttData([]);
      setPage(1); setCurrentPage(1); setTotalPages(0); setUrlPage('');
      return;
    }

    // Si vino paginado (forma esperada)
    if (res.data !== undefined) {
      setClientesAttData(res.data || []);
       setFilteredClientes(res.data || []); // <- importante
      setPage(res.current_page || pageToLoad);
      setCurrentPage(res.current_page || pageToLoad);
      setTotalPages(res.last_page || 1);
      setUrlPage(res.first_page_url || '');
      return;
    }

    // Si vino un array legacy
    if (Array.isArray(res)) {
      setClientesAttData(res);
      setFilteredClientes(res);
      setPage(1); setCurrentPage(1); setTotalPages(1); setUrlPage('');
      return;
    }

    // Fallback
    setClientesAttData([]);
    setPage(1); setCurrentPage(1); setTotalPages(0); setUrlPage('');
  } catch (err) {
    console.error('fetchDetallePage error', err);
    setClientesAttData([]);
    setPage(1); setCurrentPage(1); setTotalPages(0); setUrlPage('');
  } finally {
    setLoading(false);
  }
};

const onSearch = async () => {
  // Si no hay tipo seleccionado, no hacer nada
  if (!searchType) {
    setFilteredClientes(clientesAttData);
    return;
  }

  // 1) Si filtro por Fecha -> pedir al backend (paginado)
  if (searchType === 'Fecha') {
    if (!fechaInicio || !fechaFin) {
      alert('Seleccione fecha inicio y fecha fin.');
      return;
    }

    setLoading(true);
    try {
      // formatear a "YYYY-MM-DD 00:00:00" y "YYYY-MM-DD 23:59:59"
      const fi = `${fechaInicio} 00:00:00`;
      const ff = `${fechaFin} 23:59:59`;

      // modulo contiene el modo actual (activos/atendidos/desatendidos)
      const which = modulo || 'desatendidos';
      // recalculamos con page 1
      const codigoRaw = Clientes?.Vendedor ?? Clientes?.CodVendedor ?? Clientes?.Codigo ?? '';
      const codigo = String(codigoRaw || '').toUpperCase();

      const res = await getDetalleClientesPorCodigo(codigo, which, fi, ff, 1, true);
      if (!res) {
        setClientesAttData([]);
        setFilteredClientes([]);
        setPage(1); setCurrentPage(1); setTotalPages(0); setUrlPage('');
        return;
      }

      if (res.data !== undefined) {
        setClientesAttData(res.data || []);
        setFilteredClientes(res.data || []);
        setPage(res.current_page || 1);
        setCurrentPage(res.current_page || 1);
        setTotalPages(res.last_page || 1);
        setUrlPage(res.first_page_url || '');
      } else if (Array.isArray(res)) {
        setClientesAttData(res);
        setFilteredClientes(res);
        setPage(1); setCurrentPage(1); setTotalPages(1); setUrlPage('');
      } else {
        setClientesAttData([]);
        setFilteredClientes([]);
      }
    } catch (err) {
      console.error('onSearch (fecha) error', err);
    } finally {
      setLoading(false);
    }

    return;
  }

  // 2) Filtro cliente-side: Documento | Cliente | Vendedor
  if (searchType && searchType !== 'Fecha') {
    const term = String(searchValue || '').trim().toLowerCase();
    if (!term) {
      setFilteredClientes(clientesAttData);
      return;
    }

    const filtered = (clientesAttData || []).filter(item => {
      if (searchType === 'Documento') {
        return String(item.Codigo || item.codigo || '').toLowerCase().includes(term);
      }
      if (searchType === 'Cliente') {
        return String(item.Nombre || item.nombre || '').toLowerCase().includes(term);
      }
      if (searchType === 'Vendedor') {
        return String(item.NombreVendedor || item.NombreVendedor || '').toLowerCase().includes(term);
      }
      if (searchType === 'Codigo') {
        return String(item.Vendedor || item.Vendedor || '').toLowerCase().includes(term);
      }
      return false;
    });

    setFilteredClientes(filtered);
    // cuando hacemos filtro cliente-side, esconder paginación (opcional)
    setPage(1);
    setCurrentPage(1);
    setTotalPages(1);
  }
};

const clearFilters = () => {
  setSearchType('');
  setSearchValue('');
  setFechaInicio('');
  setFechaFin('');
  setFilteredClientes(clientesAttData || []);
  // restablecer paginación (si quieres)
  // setPage(originalPage) -- ya está manejado por fetchDetallePage
};




  return (
    <>
      <div className="d-none d-md-block d-lg-block">
        {
          (user.CodGerente !== null) ?
            <div className="row py-2">
              <div className="col text-center pt-2"><span className="text-danger" key={Clientes.Vendedor}>{Clientes.Vendedor}</span></div>
              <div className="col text-center pt-2"><span className="text-belmeny">{Clientes.Nombre}</span></div>
              <div className="col text-center">
                <button className="btn btn-primary w-50" onClick={user.Usuario.toLowerCase()  != 'haboulmoun'  ? () => handleShow('activos') : undefined}>{Clientes.ClientesAct} activos</button>
              </div>
              <div className="col text-center">
                <button className="btn btn-success w-50" onClick={user.Usuario.toLowerCase()  != 'haboulmoun'  ? () => handleShow('atendidos') : undefined}>{Clientes.Atendidos} atendidos</button>
              </div>
              <div className="col text-center">
                <button className="btn btn-danger w-75" onClick={user.Usuario.toLowerCase()  != 'haboulmoun'  ? () => handleShow('desatendidos') : undefined}>{(Clientes.ClientesAct - Clientes.Atendidos)} no atendidos</button>
              </div>
              <div className={user.Usuario.toLowerCase() == 'haboulmouna' || user.Usuario.toLowerCase() == 'cobranzasbg' ? "d-none" : "col text-center"}>
                <ClientesSupervisorXLS vendedor={Clientes.Vendedor} />
              </div>
            </div> :
            <div className="row py-2">
              <div className="col text-center pt-2"><span className="text-danger fw-bold" key={Clientes.Codigo}>{Clientes.Codigo}</span></div>
              <div className="col text-center pt-2"><span className="text-belmeny">{Clientes.Nombre}</span></div>
              <div className="col text-center pt-2">
                {
                  (Clientes.FechaDocumento !== null) ?
                    <>
                      {new Date(Clientes.FechaDocumento).toLocaleDateString()}
                    </> :
                    <>
                      N/A
                    </>
                }
              </div>
              <div className="col text-center pt-2">
                {
                  (Clientes.SaldoPendiente > 0) ?
                    <>
                      <span className='text-danger fw-bold'>${Clientes.SaldoPendiente}</span>
                    </> :
                    <>
                      <span className='text-success fw-bold'>$0</span>
                    </>
                }
              </div>
              <div className="col text-center pt-2">
                <button className="btn btn-success btn-sm w-75" onClick={() => handleShow()}>Ver detalles</button>
              </div>
            </div>
        }
      </div>

      <div className="container-fluid d-sm-block d-md-none">
        <div className="card my-3 drop-shadow border-belmeny">
          <div className="card-body">
            <div className="row">
              <div className="col-10">
                <h5 className="card-title text-belmeny">{Clientes.Nombre.toUpperCase()}</h5>
              </div>
              <div className="col-2">
                <SlOptionsVertical className='text-belmeny fs-5 float-end' style={{ cursor: 'pointer' }} onClick={() => handleShow()} />
              </div>
            </div>
            {
              (user.CodGerente !== null) ?
                <>
                  <h6 className="card-subtitle mb-2 text-muted fst-italic">{Clientes.Vendedor}</h6>
                  <h6><span className="text-belmeny fw-bold">{Clientes.ClientesAct}</span> <span className="fw-normal"> clientes activos</span> <br />
                    <span className="text-success fw-bold">{Clientes.Atendidos}</span> <span className="fw-normal"> clientes atendidos</span> <br />
                    <span className="text-danger fw-bold">{(Clientes.ClientesAct - Clientes.Atendidos)}</span> <span className="fw-normal"> clientes deudores</span> <br />
                  </h6>
                </> :
                <>
                  <h6 className="card-subtitle mb-2 text-muted fst-italic">{Clientes.Codigo}</h6>
                  {
                    (Clientes.SaldoPendiente > 0) ?
                      <><h6>Saldo Pendiente: <span className="fw-bold text-danger">${Clientes.SaldoPendiente}</span></h6></> :
                      <><h6>Saldo Pendiente: <span className="fw-bold text-belmeny">${Clientes.SaldoPendiente}</span></h6></>
                  }
                </>
            }
          </div>
        </div>
      </div>

      <Modal show={show} fullscreen={fullscreen} onHide={() => setShow(false)}>
        <Modal.Header className='bg-belmeny text-light'>
          <Modal.Title className='fst-italic'>
            {
              (user.CodGerente !== null) ?
                <>Información de los clientes del vendedor: {Clientes.Nombre}</> :
                <>Información del cliente: {Clientes.Nombre}</>
            }
          </Modal.Title>
          <Modal.Title>
            <RiCloseCircleFill className='text-danger fs-1 modal-close bg-light rounded-circle' onClick={() => setShow(false)} />
          </Modal.Title>
        </Modal.Header>
        <div className="division w-100 my-4 bg-belmeny"></div>
        <Modal.Body>

          <div className="container-fluid">
            {/* Div para escritorio */}
            <div className='d-none d-md-block d-lg-block'>
              {
                (user.CodGerente !== null) ?
                  <>
                    {
                      (loading) ?
                        <>
                          <div className="text-center">
                            <div className="m-auto spinner">
                              <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-primary" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                              </svg>
                            </div>
                          </div>
                        </> :
                        <>
                          <h4 className="text-belmeny text-center fst-italic">Lista de  {(modulo === 'activos') ? <>Activos</> : (modulo === 'atendidos') ? <>Atencion</> : <>Deudas</>}</h4>
                          <div className="table-responsive">
                            {/* ======== FILTROS (poner aquí la UI con dropdown/input/fechas) ======== */}
<div className="container mb-3">
  <div className="row align-items-center gy-2">
    <div className="col-auto">
      <select
        className="form-select"
        value={searchType}
        onChange={(e) => {
          setSearchType(e.target.value);
          setSearchValue('');
          setFechaInicio('');
          setFechaFin('');
          // reset filtered a datos actuales
          setFilteredClientes(clientesAttData || []);
        }}
        style={{ minWidth: 180 }}
      >
        <option value="">-- Filtro --</option>
        <option value="Documento">Rif</option>
        <option value="Cliente">Cliente</option>
        {user.Usuario.toLowerCase() === 'haboulmouna' || user.Usuario.toLowerCase() === 'cobranzasbg' ? (
  <option value="Vendedor">Vendedor</option>
) : null}
{user.Usuario.toLowerCase() === 'haboulmouna' || user.Usuario.toLowerCase() === 'cobranzasbg' ? (
  <option value="Codigo">Codigo Vendedor</option>
) : null}
       {/* <option value="Fecha">Fecha</option>*/}
      </select>
    </div>

    {/* input texto (Documento, Cliente, Vendedor) */}
    {searchType && searchType !== 'Fecha' ? (
      <div className="col-auto">
        <input
          type="text"
          className="form-control"
          placeholder={`Buscar por ${searchType}`}
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') onSearch(); }}
        />
      </div>
    ) : null}

    {/* inputs de fecha (si seleccionó Fecha) */}
    {searchType === 'Fecha' ? (
      <>
        <div className="col-auto">
          <input
            type="date"
            className="form-control"
            value={fechaInicio}
            onChange={(e) => setFechaInicio(e.target.value)}
          />
        </div>
        <div className="col-auto">
          <input
            type="date"
            className="form-control"
            value={fechaFin}
            onChange={(e) => setFechaFin(e.target.value)}
          />
        </div>
      </>
    ) : null}

    <div className="col-auto">
      <button className="btn btn-primary me-2" onClick={onSearch}>Buscar</button>
      <button className="btn btn-outline-secondary" onClick={clearFilters}>Limpiar</button>
    </div>

    {/* opcional: mostrar resumen de filtros activos */}
    <div className="col">
      {searchType ? (
        <small className="text-muted">
          Filtro activo: <strong>{searchType}</strong>
          {searchType !== 'Fecha' && searchValue ? ` — ${searchValue}` : ''}
          {searchType === 'Fecha' && fechaInicio && fechaFin ? ` — ${fechaInicio} a ${fechaFin}` : ''}
        </small>
      ) : <small className="text-muted">Sin filtros</small>}
    </div>
  </div>
</div>
{/* ======== FIN FILTROS ======== */}

                            <table className="table table-bordered table-hover border-belmeny mt-4">
                              <thead className='bg-belmeny text-light text-center pb-3'>
                                <th style={{ height: '40px' }} className='pb-2'>RIF</th>
                                <th className='pb-2'>Cliente</th>
                                <th className='pb-2'>Dirección</th>
                                <th className={user.Usuario.toLowerCase() === 'haboulmouna' || user.Usuario.toLowerCase() === 'cobranzasbg' ? 'pb-2' : 'd-none'}>Vendedor</th>
                                <th className={user.Usuario.toLowerCase() === 'haboulmouna' || user.Usuario.toLowerCase() === 'cobranzasbg' ? 'pb-2' : 'd-none'}>Codigo Vendedor</th>
                                {(modulo === 'activos') ? <th className='pb-2'>Fecha de Ingreso al Sistema</th> : null}
                                <th className='pb-2'>Deuda Pendiente</th>
                                <th className='pb-2'>Opciones</th>
                              </thead>
                              <tbody>
                                {
  (filteredClientes || []).map((item) => {
    return (
      (modulo === 'activos') ?
        <tr key={item.Codigo} className='fw-bold'>
          <td className='text-center text-danger' style={{ height: '50px' }}>{item.Codigo}</td>
          <td className='text-center'>{item.Nombre}</td>
          <td className='text-center'>{item.DireccionFiscal}</td>
          <td className={user.Usuario.toLowerCase() === 'haboulmouna' || user.Usuario.toLowerCase() === 'cobranzasbg' ? 'text-center' : 'd-none'}>
  {item.NombreVendedor}
</td>
      <td className={user.Usuario.toLowerCase() === 'haboulmouna' || user.Usuario.toLowerCase() === 'cobranzasbg' ? 'text-center' : 'd-none'}>
  {item.Vendedor}
</td>
          <td className='text-center'>{new Date(item.FechaIngreso).toLocaleDateString('es-MX', { timeZone: 'UTC' })}</td>
          <td className='text-center text-danger'>${item.SaldoPendiente.toFixed(2)}</td>
          
  <td className='text-center text-danger'>
    <button className='btn btn-belmeny text-white my-2' onClick={() => handleShowDetalleCliente(item.Codigo)}>Ver detalles</button>
  </td>


        </tr> :
      (modulo === 'atendidos') ?
        <tr key={item.Codigo} className='fw-bold'>
          <td className='text-center text-danger' style={{ height: '50px' }}>{item.Codigo}</td>
          <td className='text-center'>{item.Nombre}</td>
          <td className='text-center'>{item.DireccionFiscal}</td>
          <td className={user.Usuario.toLowerCase() === 'haboulmouna' || user.Usuario.toLowerCase() === 'cobranzasbg' ? 'text-center' : 'd-none'}>
  {item.NombreVendedor}
</td>
      <td className={user.Usuario.toLowerCase() === 'haboulmouna' || user.Usuario.toLowerCase() === 'cobranzasbg' ? 'text-center' : 'd-none'}>
  {item.Vendedor}
</td>
          <td className='text-center text-danger'>${item.SaldoPendiente.toFixed(2)}</td>
          
  <td className='text-center text-danger'>
    <button className='btn btn-belmeny text-white my-2' onClick={() => handleShowDetalleCliente(item.Codigo)}>Ver detalles</button>
  </td>


        </tr> :
        <tr key={item.Codigo} className='fw-bold'>
          <td className='text-center text-danger' style={{ height: '50px' }}>{item.Codigo}</td>
          <td className='text-center'>{item.Nombre}</td>
          <td className='text-center'>{item.DireccionFiscal}</td>
          <td className={user.Usuario.toLowerCase() === 'haboulmouna' || user.Usuario.toLowerCase() === 'cobranzasbg' ? 'text-center' : 'd-none'}>
  {item.NombreVendedor}
</td>
      <td className={user.Usuario.toLowerCase() === 'haboulmouna' || user.Usuario.toLowerCase() === 'cobranzasbg' ? 'text-center' : 'd-none'}>
  {item.Vendedor}
</td>
          <td className='text-center text-danger'>${item.SaldoPendiente.toFixed(2)}</td>
          
  <td className='text-center text-danger'>
    <button className='btn btn-belmeny text-white my-2' onClick={() => handleShowDetalleCliente(item.Codigo)}>Ver detalles</button>
  </td>


        </tr>
    )
  })
}

                              </tbody>
                            </table>

                            <Pagination
                              total={totalPages}
                              current={currentPage}
                              onPageChange={page => handlePageChange(page)}
                            />
                          </div>
                        </>
                    }
                  </> :
                  <div className="row">
                    <div className="col">
                      <h2 className='text-center text-belmeny'>{Clientes.Nombre}</h2>
                      <div className="division w-25 m-auto my-3 bg-belmeny"></div>

                      <div className="text-center">
                        <h4 className='badge-vendedor rounded-pill text-light m-auto drop-shadow' style={{ width: "40%" }}>VENDEDOR ENCARGADO</h4>
                        <h3 className='bg-belmeny rounded-pill text-light fw-light m-auto drop-shadow' style={{ width: "60%" }}>{vendedorInfo}</h3>
                      </div>

                      <ul className='mt-5'>
                        <li className='client-info'>
                          <h4><b>Telefono:</b> {Clientes.Telefono1}</h4>
                        </li>
                        <li className='client-info'>
                          <h4><b>Dirección Fiscal:</b> {Clientes.DireccionFiscal}</h4>
                        </li>
                        <li className='client-info'>
                          <h4><b>Limite:</b> ${Clientes.Limite}</h4>
                        </li>
                        <li className='client-info'>
                          <h4>
                            <b>Saldo Pendiente por Cobrar: </b>
                            {
                              (Clientes.SaldoPendiente > 0) ? <><span className='text-danger'> ${Clientes.SaldoPendiente}</span></> : <><span className="text-success">0</span></>
                            }
                          </h4>
                        </li>
                      </ul>

                    </div>
                    <div className="col">
                      <h3 className='text-end text-belmeny me-3 fst-italic'>{Clientes.Rif}</h3>
                      {
                        (loading) ?
                          <>
                            <div className="text-center">
                              <div className="m-auto spinner">
                                <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-primary" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                </svg>
                              </div>
                            </div>
                          </> :
                          <>
                            <Chart
                              options={chartData.options}
                              series={chartData.series}
                              type="area"
                              width="100%"
                              height="450px"
                            />
                          </>
                      }
                    </div>
                      
                    <h4 className='badge-vendedor rounded-pill text-light m-auto'>Detalle de ventas</h4>

<div className="container">
  <div className="row mt-3">
    <div className="col-1"></div>
    {
      (labels.map((month) => <div className='col bg-belmeny3 rounded text-center mx-2'><span className="text-white fs-5">{month}</span></div>))
    }
  </div>
  {/* <div className="row">
    <div className="col-1">
      <h5 className='text-belmeny mt-3'>2022</h5>
    </div>
    {(ventas2022.map((Ventas) => <div className='col text-center mt-3 text-belmeny mx-2'>{formatNumber(Ventas.ventas)} USD</div>))}
  </div> */}
  <div className="division mt-1 bg-belmeny"></div>
  <div className="row">
    <div className="col-1">
      <h5 className='text-belmeny mt-3'>2023</h5>
    </div>
    {(ventas2023.map((Ventas) => <div className='col text-center mt-3 text-belmeny mx-2'>{formatNumber(Ventas.ventas)} USD</div>))}
  </div>
  <div className="division mt-1 bg-belmeny"></div>
  <div className="row">
    <div className="col-1">
      <h5 className='text-belmeny mt-3'>2024</h5>
    </div>
    {(ventas2024.map((Ventas) => <div className='col text-center mt-3 text-belmeny mx-2'>{formatNumber(Ventas.ventas)} USD</div>))}
  </div>
  <div className="division mt-1 bg-belmeny"></div>
  <div className="row">
    <div className="col-1">
      <h5 className='text-belmeny mt-3'>2025</h5>
    </div>
    {(ventas2025.map((Ventas) => <div className='col text-center mt-3 text-belmeny mx-2'>{formatNumber(Ventas.ventas)} USD</div>))}
  </div>
</div>

<div className="division mt-3 bg-belmeny"></div>
<h3 className="text-end text-belmeny fst-italic mt-2 pe-5">Belmeny Group C.A</h3>
                  </div>
              }
            </div>

            {/* Div para móvil */}
            <div className='d-sm-block d-md-none'>
              {
                (user.CodGerente !== null) ?
                  <>
                  </> :
                  <div className="row">
                    <div className="row">
                      <h4 className='text-center text-belmeny fst-italic'>{Clientes.Rif}</h4>
                      <h3 className='text-center text-belmeny'>{Clientes.Nombre}</h3>
                      <div className="division w-50 m-auto my-3 bg-belmeny"></div>
                      <div className="text-center">
                        <h4 className='badge-vendedor rounded-pill text-light m-auto' style={{ width: "80%", position: "relative", left: "auto", top: "15%" }}>VENDEDOR ENCARGADO</h4>
                        <h3 className='bg-belmeny rounded-pill text-light fw-light m-auto pt-3' style={{ width: "100%" }}>{vendedorInfo}</h3>
                      </div>
                    </div>
                    <ul className='mt-5'>
                      <li className='client-info'>
                        <h4><b>Telefono:</b> {Clientes.Telefono1}</h4>
                      </li>
                      <li className='client-info'>
                        <h4><b>Dirección Fiscal:</b> {Clientes.DireccionFiscal}</h4>
                      </li>
                      <li className='client-info'>
                        <h4><b>Limite:</b> ${Clientes.Limite}</h4>
                      </li>
                      <li className='client-info'>
                        <h4>
                          <b>Saldo Pendiente por Cobrar:</b>
                          {
                            (Clientes.SaldoPendiente > 0) ?
                              <>
                                <span className='text-danger'>${Clientes.SaldoPendiente}</span>
                              </> :
                              <>
                                <span>${Clientes.SaldoPendiente}</span>
                              </>
                          }
                        </h4>
                      </li>
                    </ul>
                    <div className="division bg-belmeny my-3"></div>
                    {
                      (loading) ?
                        <>
                          <div className="text-center">
                            <div className="m-auto spinner">
                              <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-primary" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                              </svg>
                            </div>
                          </div>
                        </> :
                        <>
                          <Chart
                            options={chartData.options}
                            series={chartData.series}
                            type="area"
                            width="100%"
                            height="450px"
                          />
                        </>
                    }
                  </div>
              }

            </div>

          </div>
        </Modal.Body>
      </Modal>

      <Modal show={showDetalleCliente} fullscreen={fullscreen} onHide={() => setShowDetalleCliente(false)}>
        {
          (loading) ?
            <>
              <div className="text-center">
                <div className="m-auto spinner">
                  <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-primary" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                </div>
              </div>
            </> :
            <>
              <Modal.Header className='bg-belmeny text-light'>
                <Modal.Title className='fst-italic'>
                  Información del cliente: {clienteData.Nombre}
                </Modal.Title>
                <Modal.Title>
                  <RiCloseCircleFill className='text-danger fs-1 modal-close bg-light rounded-circle' onClick={() => setShowDetalleCliente(false)} />
                </Modal.Title>
              </Modal.Header>
              <div className="division w-100 my-4 bg-belmeny"></div>
              <Modal.Body>

                <div className="container-fluid">
                  {/* Div para escritorio acaaa*/}
                  <div className='d-none d-md-block d-lg-block'>
                    <div className="row">
                      <div className="col">
                        <h2 className='text-center text-belmeny'>{clienteData.Nombre}</h2>
                        <div className="division w-25 m-auto my-3 bg-belmeny"></div>

                        {user.Usuario.toLowerCase() != 'haboulmouna' && user.Usuario.toLowerCase() != 'cobranzasbg' ? (
                          <div className="text-center">
                            <h4 className='badge-vendedor rounded-pill text-light m-auto drop-shadow' style={{ width: "40%" }}>VENDEDOR ENCARGADO</h4>
                            <h3 className='bg-belmeny rounded-pill text-light fw-light m-auto drop-shadow' style={{ width: "60%" }}>{vendedorInfo}</h3>
                          </div>
                        ) : null}

                        <ul className='mt-5'>
                          <li className='client-info'>
                            <h4><b>Telefono:</b> {clienteData.Telefono1}</h4>
                          </li>
                          <li className='client-info'>
                            <h4><b>Dirección Fiscal:</b> {clienteData.DireccionFiscal}</h4>
                          </li>
                          <li className='client-info'>
                            <h4><b>Limite:</b> ${clienteData.Limite}</h4>
                          </li>
                          <li className='client-info'>
                            <h4>
                              <b>Saldo Pendiente por Cobrar: </b>
                              {
                                (clienteData.SaldoPendiente > 0) ? <><span className='text-danger'> ${clienteData.SaldoPendiente}</span></> : <><span className="text-success">0</span></>
                              }
                            </h4>
                          </li>
                        </ul>

                      </div>
                      <div className="col">
                        <h3 className='text-end text-belmeny me-3 fst-italic'>{clienteData.Rif}</h3>
                        {
                          (loading) ?
                            <>
                              <div className="text-center">
                                <div className="m-auto spinner">
                                  <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-primary" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                  </svg>
                                </div>
                              </div>
                            </> :
                            <>
                              <Chart
                                options={chartData.options}
                                series={chartData.series}
                                type="area"
                                width="100%"
                                height="450px"
                              />
                             
                            </>
                        }
                      </div>

                      <h4 className='badge-vendedor rounded-pill text-light m-auto'>Detalle de ventas</h4>

<div className="container">
  <div className="row mt-3">
    <div className="col-1"></div>
    {
      (labels.map((month) => <div className='col bg-belmeny3 rounded text-center mx-2'><span className="text-white fs-5">{month}</span></div>))
    }
  </div>
  {/* <div className="row">
    <div className="col-1">
      <h5 className='text-belmeny mt-3'>2022</h5>
    </div>
    {(ventas2022.map((Ventas) => <div className='col text-center mt-3 text-belmeny mx-2'>{formatNumber(Ventas.ventas)} USD</div>))}
  </div> */}
  <div className="division mt-1 bg-belmeny"></div>
  <div className="row">
    <div className="col-1">
      <h5 className='text-belmeny mt-3'>2023</h5>
    </div>
    {(ventas2023.map((Ventas) => <div className='col text-center mt-3 text-belmeny mx-2'>{formatNumber(Ventas.ventas)} USD</div>))}
  </div>
  <div className="division mt-1 bg-belmeny"></div>
  <div className="row">
    <div className="col-1">
      <h5 className='text-belmeny mt-3'>2024</h5>
    </div>
    {(ventas2024.map((Ventas) => <div className='col text-center mt-3 text-belmeny mx-2'>{formatNumber(Ventas.ventas)} USD</div>))}
  </div>
  <div className="division mt-1 bg-belmeny"></div>
  <div className="row">
    <div className="col-1">
      <h5 className='text-belmeny mt-3'>2025</h5>
    </div>
    {(ventas2025.map((Ventas) => <div className='col text-center mt-3 text-belmeny mx-2'>{formatNumber(Ventas.ventas)} USD</div>))}
  </div>
</div>

<div className="division mt-3 bg-belmeny"></div>
<h3 className="text-end text-belmeny fst-italic mt-2 pe-5">Belmeny Group C.A</h3>
                    </div>
                  </div>

                  {/* Div para móvil */}
                  <div className='d-sm-block d-md-none'>
                    <div className="row">
                      <div className="row">
                        <h4 className='text-center text-belmeny fst-italic'>{clienteData.Rif}</h4>
                        <h3 className='text-center text-belmeny'>{clienteData.Nombre}</h3>
                        <div className="division w-50 m-auto my-3 bg-belmeny"></div>
                        <div className="text-center">
                          <h4 className='badge-vendedor rounded-pill text-light m-auto' style={{ width: "80%", position: "relative", left: "auto", top: "15%" }}>VENDEDOR ENCARGADO</h4>
                          <h3 className='bg-belmeny rounded-pill text-light fw-light m-auto pt-3' style={{ width: "100%" }}>{vendedorInfo}</h3>
                        </div>
                      </div>
                      <ul className='mt-5'>
                        <li className='client-info'>
                          <h4><b>Telefono:</b> {clienteData.Telefono1}</h4>
                        </li>
                        <li className='client-info'>
                          <h4><b>Dirección Fiscal:</b> {clienteData.DireccionFiscal}</h4>
                        </li>
                        <li className='client-info'>
                          <h4><b>Limite:</b> ${clienteData.Limite}</h4>
                        </li>
                        <li className='client-info'>
                          <h4>
                            <b>Saldo Pendiente por Cobrar:</b>
                            {
                              (clienteData.SaldoPendiente > 0) ?
                                <>
                                  <span className='text-danger'>${clienteData.SaldoPendiente}</span>
                                </> :
                                <>
                                  <span>${clienteData.SaldoPendiente}</span>
                                </>
                            }
                          </h4>
                        </li>
                      </ul>
                      <div className="division bg-belmeny my-3"></div>
                      {
                        (loading) ?
                          <>
                            <div className="text-center">
                              <div className="m-auto spinner">
                                <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-primary" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                </svg>
                              </div>
                            </div>
                          </> :
                          <>
                            <Chart
                              options={chartData.options}
                              series={chartData.series}
                              type="area"
                              width="100%"
                              height="450px"
                            />
                          </>
                      }
                    </div>
                  </div>
                </div>
              </Modal.Body>
            </>
        }
      </Modal>
    </>
  )
}
